import React from 'react';
import { Link } from 'react-router-dom';
import NewsLetter from '../components/NewsLetter';

const ComingSoonPage = () => {
    return (
        <div className="coming-soon-page">
            <div className="container" style={{ paddingTop: '100px', textAlign: 'center' }}>
                <div className="row justify-content-center">
                    <div className="col-lg-8">
                        <h2 style={{ fontSize: '4rem', color: '#f3b806', marginBottom: '20px' }}>
                            Bientôt disponible
                        </h2>
                        <p style={{ marginBottom: '30px', fontSize: '18px', color: '#666' ,}}>
                            Nous travaillons dur pour vous apporter ce service. Restez à l'écoute !
                        </p>
                        <Link to="/" className="btn" style={{
                            backgroundColor: '#f3b806',
                            color: '#fff',
                            padding: '12px 30px',
                            textTransform: 'uppercase',
                            fontWeight: '600',
                            borderRadius: '30px',
                        }}>
                            Retour à l'accueil
                        </Link>
                    </div>
                </div>
            </div>
            <NewsLetter />
        </div>
    );
};

export default ComingSoonPage;
